
var app = app || {} ;

(function( ){


//------------------------------------------------------------------------------------------------------------------------------


	var Main = function( )
	{
		var _this = this , i ;

		app.ua = new app.UserAgent();

		var intro = new app.Intro();

		new app.Profile();

		new app.Song();

		// new debutCountDown('2018/3/8 13:16:00');
		new debutCountDown('2018/3/10 12:00:00');

		// Campaignで使用
		var leftTextureList = [];
		for(i = 1; i<=5; i++) {
			leftTextureList[i] = PIXI.Texture.fromImage('./assets/benzaiten/img/pc/campaign/particle/object_' + i + '.png');
		}
		new campaignParticle( '.ball__particle--left', 265, 272, leftTextureList );

		var rightTextureList = [];
		rightTextureList[1] = PIXI.Texture.fromImage('./assets/benzaiten/img/pc/campaign/particle/object_6.png');
		new campaignParticle( '.ball__particle--right', 256, 241, rightTextureList );


		//スクロールイベント
		this.scrollTriggerElements = document.getElementsByClassName( 'c-title0' );
		addParallax( this.scrollTriggerElements, 0.3 );
		var movie = document.getElementById( 'movie' );
		var movies = movie.getElementsByClassName( 'movie' );
		addParallax( movies, 0.3 );
		var playerJacket = document.getElementsByClassName( 'player__jacket' );
		addParallax( playerJacket, 0.4 );


		// リサイズイベントを使うときは、この_onResize内に処理を書いてください。
		// リサイズイベントを綱わないようでしたら決してください。
		// var _onResize = function( )
		// {

		// }

		// _onResize( ) ;
		// FitContents.addTask( _onResize ) ;


		window.onload = function(){
			setTimeout(function(){
				intro.opening(function(){
					app.audioManager = new app.AudioManager();
				}.bind( this ));
			}, 500 );
		}.bind(this);

	}


	function addParallax( targets, scale ){

		ScrollEnterEvent.add( targets , { func:function(evt){
			evt.target.className += " parallax" ;
		} , marginScale:scale } ) ;

	}

	var debutCountDown = function(targetTime) {
		var i, hour, minutes, sec, hh, mm, ss;
		// 自動で情報を更新するときのタイマーIDを管理
		var autoUpdateTimerId = null;
		// 関数を呼び出した回数を管理
		var autoUpdateCount = 0;
		// 公開日時
		var debutDate = new Date(targetTime);
		// サーバーの日時
		var serverDate = null;
		// 滞在時間
		var stayTime = 0;
		// var stayTimer;
		// 残り時間
		var diffServerTime = null;
		// 残り時間
		var diff = 0;
		var diffView = 0;
		// クラスを入れ替える対象
		var targetList = document.getElementsByClassName('countdown__counter');
		// パララックス用
		var debutContainer = document.getElementsByClassName('debut__container')[0];
		// 残り1分
		var isLast = false;
		// ローカルチェック
		var isLocal = /localtime/.test(location.search);

		// var countdown = document.getElementsByClassName('debut__countdown');
		// var countdownBg = document.getElementsByClassName('debut__countdown--bg');
		// var release = document.getElementsByClassName('debut__release');
		// var releaseBg = document.getElementsByClassName('debut__release--bg');

		init();

		function init() {
			$('.debut__release').hide();
			$('.debut__release--bg').hide();
			$('.countdwon__content--last').hide();

			for(i = 0; i<targetList.length; i ++) {
				targetList[i].defClassName = targetList[i].className;
				targetList[i].className = targetList[i].defClassName + ' num0';
			}

			new ServerTime( function(evt) {
				// 滞在時間をカウントする
				// stayTimer = setInterval( stayTimeUpdate, 1000 );

				// URLに?localtimeを付与した場合は端末のローカル時間を参照する
				if(isLocal) {
					serverDate = new Date();
				} else {
					serverDate = evt.date;
				}

				diffServerTime = debutDate.getTime() - serverDate.getTime();
				setView();
			} );
		}

		// // 残り時間をミリ秒で返す
		// function stayTimeUpdate() {
		// 	stayTime++;
		// }

		// 残り時間をミリ秒で返す
		function checkDiff() {
			stayTime = new Date().getTime() - serverDate.getTime();
			return diffServerTime - stayTime;
			// return debutDate.getTime() - (serverDate.getTime() + stayTime * 1000);
		}

		// 初回に既に公開済みでないか判定する
		function setView() {
			diff = checkDiff();

			if(diff <= 0) {
				changeReleaseView(0);
			} else {
				// 残り1分以上の場合、オープニングの演出を設定する
				if(diff > 60000 ) {
					addParallax( debutContainer, 0.2 );
				} else {
					ScrollEnterEvent.add( debutContainer , { func:function(evt){
						evt.target.className += " parallax0" ;
					} , marginScale:0 } ) ;

					// $('.countdwon__content--first').hide();
					// $('.countdwon__content--last').show();
				}
				// カウントダウン開始
				executeCountDown();
			}
		}

		// カウントダウン画面 -> デビュー後画面の切り替え(一旦フェードイン/アウト)
		function changeReleaseView(animTime) {
			// 画面切り替え時は必ずこの関数を呼び出すので、ここでタイマーをclearする
			//clearInterval(stayTimer);

			$('.debut__countdown').fadeOut(animTime);
			$('.debut__countdown--bg').fadeOut(animTime, function(){
				$('.debut__release').fadeIn(animTime);
				$('.debut__release--bg').fadeIn(animTime);
			});
		}

		// カウントダウン実行
		function executeCountDown() {
			autoUpdateCount++;

			if(autoUpdateCount%10 == 1) {
				diff = checkDiff();

				if(diff <= 0) {
					targetList[4].className = targetList[4].defClassName + ' num0';
					targetList[5].className = targetList[5].defClassName + ' num0';
					// 公開後
					window.cancelAnimationFrame( autoUpdateTimerId );
					// 画面切り替え
					changeReleaseView(600);

				} else {
					// カウントダウン中
					// 残り時間を分で取得
					diffView = Math.ceil(diff / 1000 / 60);

					minutes = (Math.floor(diffView % 60)).toString();
					hour = (Math.floor(diffView / 60)).toString();

					sec = (Math.ceil(diff / 1000 % 60)).toString();

					// hour = Math.floor(diff / 1000 / 60 / 60) % 24;
					// 一桁の場合は0を付与する
					hh = ( hour.length==1 ) ? '0' + hour : hour;
					mm = ( minutes.length==1 ) ? '0' + minutes : minutes;
					ss = ( sec.length==1 ) ? '0' + sec : sec;

					// 残り1分を判定
					if(diff > 0 && diff <= 60000 ) {
						// 切り替えアニメーションなどを発生させる
						if(!isLast) {
							isLast = true;

							// 時間と分のタイマーをフェードアウトして秒を表示させる
							$('.countdwon__content--first').fadeOut(200, function(){
								$('.countdwon__content--last').fadeIn(400);
							});

							// ループ演出
							var title = document.getElementsByClassName('countdown__title-wrap')[0];
							title.className += ' effect';
						}
						// 秒のカウントダウン
						targetList[4].className = targetList[4].defClassName + ' num' + ss.charAt(0);
						targetList[5].className = targetList[5].defClassName + ' num' + ss.charAt(1);

					} else {
						// 時間,分のカウントダウン
						targetList[0].className = targetList[0].defClassName + ' num' + hh.charAt(0);
						targetList[1].className = targetList[1].defClassName + ' num' + hh.charAt(1);
						targetList[2].className = targetList[2].defClassName + ' num' + mm.charAt(0);
						targetList[3].className = targetList[3].defClassName + ' num' + mm.charAt(1);
					}

					autoUpdateTimerId = window.requestAnimationFrame( executeCountDown );
					autoUpdateCount = 0;
				}
			}
		}
	}


	var campaignParticle = function( className, w, h, texture )
	{
		var i;
		var textureList = texture;
		var particleList = [];
		var particleSize = 10; // パーティクルのサイズ
		var stageWidth = w;
		// var width = Math.round($(className).css('width').replace('px', ''));
		// var width = parseInt( $(className).css('width') );
		var stageHeight = h;
		// var height = Math.round($(className).css('height').replace('px', ''));
		// var height = parseInt( $(className).css('height') ); // Math.Floorと同じ挙動になるので、小数点が含まれる場合は注意

		var count = 0; // 間隔の判定用変数
		var INTERVAL = 15; // パーティクルを生成する間隔
		var AMOUNT = 3; // 1回に生成するパーティクルの数

		var GRAVITY = 0; // 重力
		var FRICTION = 0.96; // 摩擦
		var MAX_LIFE = 35; // 寿命
		var RANGE_X = 9; // x軸上の移動距離
		var RANGE_Y = 9; // y軸上の移動距離
		var BIAS_X = 0.5; // 0:右に重み付け 1:左に重み付け
		var BIAS_Y = 0.5; // 0:下に重み付け 1:上に重み付け

		var container = new PIXI.Container();
		// var renderer = new PIXI.autoDetectRenderer(stageWidth, stageHeight, {transparent: true});
		var renderer = new PIXI.autoDetectRenderer(stageWidth, stageHeight, {backgroundColor: 0xfff6c4});
		$(className).append(renderer.view);

		var bg = new PIXI.Graphics();
		bg.lineStyle(0);
		bg.beginFill('0xFFFFFF', 1);
		bg.drawCircle(0, 0, 186/2);
		bg.endFill();
		bg.x = renderer.width / 2;
		bg.y = renderer.height / 2;
		container.addChild(bg);

		// レンダリング開始
		requestAnimationFrame(update);

		// パーティクルを発生
		function emitParticles() {
			// for文を作成 (上限数はパーティクルの個数)
			for (i = 0; i < AMOUNT; i++) {
				// rgbを16進数で取得
				var color = hslToRgb16(getRandomRange(0, 360), 100, getRandomRange(70, 75));

				if(textureList) {
					var particle = new PIXI.Sprite(textureList[getRandomRange(1, textureList.length)]);
					particle.tint = '0x' + color.red + color.green + color.blue;
				} else {
					// グラフィックを作成
					var particle = new PIXI.Graphics();
					particle.lineStyle(0);
					particle.beginFill('0x' + color.red + color.green + color.blue, 1);
					particle.drawCircle(0, 0, particleSize);
					// particle.drawCircle(0, 0, particleSize * Math.random());
					particle.endFill();
				}

				container.addChild(particle);

				particle.vx = RANGE_X * (Math.random() - BIAS_X);
				particle.vy = RANGE_Y * (Math.random() - BIAS_Y);

				particle.life = MAX_LIFE;

				particle.x = renderer.width / 2;
				// particle.x = renderer.width * Math.random();
				particle.y = renderer.height / 2;

				particleList.push(particle);
			}
		}

		// パーティクルを更新
		function updateParticles() {
			for (i = 0; i < particleList.length; i++) {
				// i番目の要素を変数に代入
				var particle = particleList[i];

				// 重力
				particle.vy += GRAVITY;

				// 摩擦
				particle.vx *= FRICTION;
				particle.vy *= FRICTION;

				// 反映
				particle.x += particle.vx;
				particle.y += particle.vy;

				// 寿命に応じてサイズを変更する
				var scale = particle.life / MAX_LIFE;
				particle.scale.x = particle.scale.y = scale;
				// particle.alpha = scale;

				// 寿命を減らす
				particle.life -= 0.3;

				// 寿命の判定
				if (particle.life <= 0) {
					// ステージから削除
					container.removeChild(particle);
					// 配列からも削除
					particleList.splice(i, 1);
				}
			}
		}

		function update() {
			count++;

			// countが10の時にパーティクルを生成
			if(count == INTERVAL) {
				count = 0;
				emitParticles();
			}

			// パーティクルを更新
			updateParticles();

			// 画面の更新
			renderer.render(container);
			requestAnimationFrame(update);
		}

		// 指定した範囲の中でランダムの値を返す
		function getRandomRange(min, max) {
			if (max) {
				return Math.random() * (max - min + 1) + min | 0;
			} else {
				return Math.random() * min | 0;
			}
		}

		// rgbを16進数で返す
		function hslToRgb16(hue, saturation, lightness) {
			var result = false;

			if (((hue || hue === 0) && hue <= 360) && ((saturation || saturation === 0) && saturation <= 100) && ((lightness || lightness === 0) && lightness <= 100)) {
				var red   = 0,
					green = 0,
					blue  = 0,
					q     = 0,
					p     = 0,
					hueToRgb;

				hue        = Number(hue)        / 360;
				saturation = Number(saturation) / 100;
				lightness  = Number(lightness)  / 100;

				if (saturation === 0) {
					red   = lightness;
					green = lightness;
					blue  = lightness;
				} else {
					hueToRgb = function(p, q, t) {
						if (t < 0) {
							t += 1;
						}

						if (t > 1) {
							t -= 1;
						}

						if (t < 1 / 6) {
							p += (q - p) * 6 * t;
						} else if (t < 1 / 2) {
							p = q;
						} else if (t < 2 / 3) {
							p += (q - p) * (2 / 3 - t) * 6;
						}

						return p;
					};

					if (lightness < 0.5) {
						q = lightness * (1 + saturation);
					} else {
						q = lightness + saturation - lightness * saturation;
					}
					p = 2 * lightness - q;

					red   = hueToRgb(p, q, hue + 1 / 3);
					green = hueToRgb(p, q, hue);
					blue  = hueToRgb(p, q, hue - 1 / 3);
				}

				result = {
					red   : Math.round(red   * 255).toString(16),
					green : Math.round(green * 255).toString(16),
					blue  : Math.round(blue  * 255).toString(16)
				};
			}

			return result;
		}
	}


//------------------------------------------------------------------------------------------------------------------------------


	window.requestAnimationFrame = 	window.requestAnimationFrame ||
									window.webkitRequestAnimationFrame ||
									function( func ){ return setTimeout( func , 1000/60 ) ; } ;


	window.cancelAnimationFrame = 	window.cancelAnimationFrame ||
									window.webkitCancelAnimationFrame ||
									function( id ){ clearTimeout( id ) ; } ;


	document.readyState === "complete"
		? setTimeout( function(){ new Main( ) ; } , 1 )
		: document.addEventListener( "DOMContentLoaded", function(){ new Main( ) ; } ) ;


//------------------------------------------------------------------------------------------------------------------------------


} )( ) ;




/****************************************************************/
//UserAgent
/****************************************************************/
app.UserAgent = (function(){

	function UserAgent(){

		var ua = navigator.userAgent.toLowerCase();
		var ver = window.navigator.appVersion.toLowerCase();
		var browser = '';
		var ieVer = 9999;
		if (ua.indexOf("msie") != -1){
			browser = 'ie';
	        if (ver.indexOf("msie 6.") != -1){
	            ieVer = 6;
	        }else if (ver.indexOf("msie 7.") != -1){
	            ieVer = 7;
	        }else if (ver.indexOf("msie 8.") != -1){
	            ieVer = 8;
	        }else if (ver.indexOf("msie 9.") != -1){
	            ieVer = 9;
	        }else if (ver.indexOf("msie 10.") != -1){
	            ieVer = 10;
	        }
	    }else if(ua.indexOf('trident/7') != -1){
	        browser = 'ie';
	        ieVer = 11;
	    }else if (ua.indexOf('chrome') != -1) {
		    browser = 'chrome';
		} else if (ua.indexOf('safari') != -1) {
		    browser = 'safari';
		} else if (ua.indexOf('firefox') != -1) {
		    browser = 'firefox';
		} else if (ua.indexOf('opera') != -1) {
		    browser = 'opera';
		}

		ua = navigator.userAgent;
		var twitterFlag = false;
		if (ua.search(/Twitter/) != -1)
		    twitterFlag = true;
		var platform = 'pc';
		if (ua.search(/iPhone/) != -1) {
		    platform = "sp";
		} else if ((ua.search(/Android/) != -1) && (ua.search(/Mobile/) != -1)) {
		    platform = "sp";
		} else if ((ua.search(/iPad/) != -1) || (ua.search(/Android/) != -1)) {
		    platform = "ipad";
		}

		this.browser = browser;
		this.ieVer = ieVer;
		this.platform = platform;



		this.isAndroid = (navigator.userAgent.search(/Android/)> 0)?true:false;
		this.androidVersion = -1;
		if( this.isAndroid ) this.androidVersion = parseFloat(ua.slice(ua.indexOf("Android")+8));

		this.is_iOS = (navigator.userAgent.search(/iPhone/)> 0 || navigator.userAgent.search(/iPod/)> 0 || navigator.userAgent.search(/iPad/)> 0)?true:false;
		this.iosVersion = -1;
		if( this.is_iOS ){
			var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
	        this.iosVersion = [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
		}
	}

	return UserAgent;

})();
